function Imageshow ({image}){ //รับ props image (image มีค่าเท่ากับ Array ของ response ที่แยกออกมาทีละตัวโดยใช้ map ) มาจาก Imagelist.js
    return(
        <div>
            <img src = {image.urls.small} alt={image.alt_description}  /> {/*นำมาแสดงเป็นภาพ */}
            
            </div>
    )
}
export default Imageshow